<template>
    <div class="contact">
        <div v-show="info.verify_status !== 3 && !info.is_private" class="contact-status">
            <v-status-bar v-show="info.verify_status === 1" kind="wait" :content="`企业联系方式变更审核中（修改时间${info.verify_time})`" />
            <v-status-bar v-show="info.verify_status === 0" kind="success" :content="`企业联系方式变更成功，生效时间：${info.verify_time}`" show-close-icon @close="closeStatusBar" />
            <v-status-bar v-show="info.verify_status === 2" kind="serious-warning" show-close-icon @close="closeStatusBar">
                <span>企业联系方式变更失败，失败原因：<br>
                    <div v-for="(item, index) in info.verify_reason" :key="index">
                        <span>{{ `${index + 1}、${item}` }}</span>
                    </div>
                </span>
            </v-status-bar>
        </div>
        <v-page-header title="企业管理员" :caption="info.company" />
        <div class="contact-container">
            <div class="contact-container-name contact-container-item">
                <v-form ref="nameForm" kind="desc" @submit="submitName">
                    <v-form-item name="name" error-placement="top-right" label="姓名" :rules="rules.name">
                        <v-input
                            v-model="info.name"
                            name="name"
                            class="default-input"
                            placeholder="请输入用户名"
                            :width="254"
                            limit="24"
                            :length-calculator="externalNameCalc"
                            :disabled="!corp_admin.name_can_edit"
                            :clearable="false"
                            @blur="blurName"
                            @focus="focusName"
                        />
                        <v-button v-show="isEditName" type="link" kind="primary" class="default-input-opt" @click="handleChangeName">
                            保存
                        </v-button>
                        <v-button v-show="isEditName" type="link" class="default-input-opt" kind="primary" @click="cancelChangeName">
                            取消
                        </v-button>
                    </v-form-item>
                </v-form>
            </div>
            <div v-if="info.mobile" class="contact-container-mobile contact-container-item">
                <v-form kind="desc">
                    <v-form-item name="mobile" error-placement="top-right" label="管理员手机" desc="用于登录账户中心进行管理操作并接收重要的验证信息，请使用企业主或管理员的手机号，避免登录和接收信息出错">
                        <v-input
                            :value="info.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')"
                            name="mobile"
                            class="default-input"
                            placeholder="请输入管理员手机"
                            :clearable="false"
                            disabled
                            :width="254"
                        />
                        <v-button-group class="default-input-btn-group">
                            <v-button v-show="showLoginMobile && in_contact_whitelist" type="link" kind="primary" class="default-input-opt" :disabled="!corp_admin.phone_can_edit || info.verify_status === 1" @click="toLoginMobile">
                                升级为登录账号
                            </v-button>
                            <v-button type="link" class="default-input-opt" kind="primary" :disabled="!corp_admin.phone_can_edit || info.verify_status === 1" @click="changeMobile">
                                修改手机号
                            </v-button>
                        </v-button-group>
                    </v-form-item>
                </v-form>
            </div>
            <div class="contact-container-email contact-container-item">
                <v-form ref="emailForm" kind="desc" @submit="submitEmail">
                    <v-form-item name="email" error-placement="top-left" label="邮箱地址" :rules="rules.email" desc="用于接收腾讯企点发送的业务通知">
                        <v-input
                            v-model="info.email"
                            name="email"
                            class="default-input"
                            placeholder="请输入邮箱地址"
                            :clearable="false"
                            :width="254"
                            :disabled="!corp_admin.email_can_edit"
                            @blur="blurEmail"
                            @focus="focusEmail"
                        />
                        <v-button v-show="isEditEmail" type="link" kind="primary" class="default-input-opt" @click="handleChangeEmail">
                            保存
                        </v-button>
                        <v-button v-show="isEditEmail" type="link" class="default-input-opt" kind="primary" @click="cancelChangeEmail">
                            取消
                        </v-button>
                    </v-form-item>
                </v-form>
            </div>
            <div v-show="info.admin_qq" class="contact-container-qq contact-container-item">
                <v-form kind="desc">
                    <v-form-item name="qq" error-placement="top-right" label="管理员QQ" desc="用于登录账户中心进行管理操作请使用个人QQ作为管理员登录账号，避免登录出错">
                        <v-input
                            :value="info.admin_qq.replace(/(\d{5})/, '*****')"
                            name="qq"
                            class="default-input"
                            placeholder="请输入用户名"
                            :width="254"
                            disabled
                            :clearable="false"
                        />
                        <v-button type="link" kind="primary" :disabled="!corp_admin.admin_can_edit || info.verify_status === 1" class="default-input-opt" @click="changeQQ">
                            修改QQ账号
                        </v-button>
                    </v-form-item>
                </v-form>
            </div>
        </div>
        <change-tel-dialog
            ref="mobileDlg"
            :show-dialog="changeMobileDlg"
            :mobile="info.mobile"
            :to-login-account="toLoginAccount"
            :is-change-tel="isChangeTel"
            @on-bind-success="getInfo"
            @refresh-login-mobile="getInfo"
            @close="closeMobileDlg"
            @openApplication="openApplication"
        />
        <change-QQ-dialog
            v-if="qqDialogRender"
            ref="qqDlg"
            :show-dialog="changeQQDlg"
            :mobile="info.mobile"
            @on-bind-success="getInfo"
            @close="closeQQDlg"
            @openApplication="openApplication"
        />
        <application v-if="dialogRender" :dialog-status="dialogStatus" :info="applicationInfo" @cancel="cancel" />
    </div>
</template>
<script>
    import changeTelDialog from './components/change-tel-dialog.vue';
    import application from './components/application.vue';
    import changeQQDialog from './components/change-qq-dialog.vue';

    import { cookie } from '@tencent/qd-lib';
    export default {
        components: {
            changeTelDialog,
            application,
            changeQQDialog,
        },
        data() {
            return {
                isEditName: false,
                preName: '',
                isEditEmail: false,
                preEmail: '',
                corp_admin: {
                    name_can_edit: true,
                    email_can_edit: true,
                    phone_can_edit: true,
                    admin_can_edit: true,
                },
                loginMobile: '',
                in_contact_whitelist: false,
                info: {
                    show: false,
                    name: '',
                    email: '',
                    mobile: '',
                    admin_qq: '',
                    admin_qq_openid: '',
                    is_private: '',
                    company: '',
                    verify_status: -1,
                    verify_reason: [],
                    verify_time: '',
                },
                showLoginMobile: false,
                dialogStatus: false,
                changeMobileDlg: false,
                toLoginAccount: false,
                changeQQDlg: false,
                isChangeTel: false,
                from: '',
                rules: {
                    name: [{
                        required: true,
                        message: '请输入姓名',
                    }],
                    email: [
                        {
                            required: true,
                            message: '请输入邮箱地址',
                        },
                        {
                            validate: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/,
                            message: '请输入正确的邮箱地址',
                            trigger: 'input',
                        },
                    ],
                },
                dialogRender: false,
                qqDialogRender: false,
            };
        },
        computed: {
            applicationInfo() {
                return {
                    ...this.info,
                    defaultSelect: [this.from],
                    corp_uin: this.corp_uin,
                };
            },
        },
        async created() {
            this.corp_uin = cookie.get('corp_uin'),
            await this.getInfo();
            this.inWhiteList();
            if (this.info.is_private) {
                this.getPrivateCorpFlag();
            }
        },
        methods: {
            externalNameCalc(str) {
                if (str == null) return 0;
                if (typeof str != 'string') {
                    str += '';
                }
                return str.replace(/[^\x00-\xff]/g, '01').length;
            },
            focusName() {
                this.isEditName = true;
            },
            cancelChangeName() {
                this.$set(this.info, 'name', this.preName);
                this.isEditName = false;
            },
            blurName() {
                this.isEditName = this.preName !== this.info.name;
            },
            focusEmail() {
                this.isEditEmail = true;
            },
            cancelChangeEmail() {
                this.$set(this.info, 'email', this.preEmail);
                this.isEditEmail = false;
            },
            blurEmail() {
                this.isEditEmail = this.preEmail !== this.info.email;
            },
            inWhiteList() {
                const params = {
                    useruin: Number(this.corp_uin) || 0,
                    item_key: [
                        {
                            conf_key: 'support_admin_mobile',
                            version: 0,
                        },
                    ],
                };
                this.$ajax.gatewayPost('/v1/customer_defined_conf/get_conf', params).then((res) => {
                    const result = res.item_key && res.item_key[0];
                    const value = result && result.value;
                    this.in_contact_whitelist = value === '1';
                });
            },
            getPrivateCorpFlag() {
                this.$ajax.post('/mng/account/corpInfo/getPrivateCorpFlag').then((res) => {
                    const { data } = res;
                    this.corp_admin = data.corp_admin || this.corp_admin;
                });
            },
            openApplication(data) {
                this.from = data;
                this.dialogRender = true;
                this.$nextTick(() => {
                    this.dialogStatus = true;
                });
            },
            closeMobileDlg() {
                this.changeMobileDlg = false;
            },
            closeQQDlg() {
                this.changeQQDlg = false;
                this.$nextTick(() => {
                    this.qqDialogRender = false;
                });
            },
            changeQQ() {
                this.qqDialogRender = true;
                this.$nextTick(() => {
                    this.changeQQDlg = true;
                });
            },
            closeStatusBar() {
                this.$ajax.post('/mng/account/contacts/updateContactTips').then((res) => {
                    this.$message.success('关闭成功');
                });
            },
            getAdminMobile() {
                const params = {
                    corpid: this.corp_uin,
                };
                this.$ajax.gatewayGet('/v1/basic.account.account_web.Account/AdminMobile', params).then((res) => {
                    const { data } = res;
                    this.loginMobile = data.mobile;
                    this.showLoginMobile = data.mobile !== this.info.mobile;
                });
            },
            getInfo() {
                const params = {
                    corp_id: this.corp_uin,
                };
                return new Promise((resolve, reject) => {
                    this.$ajax.gatewayPost('/v1/basic/corp/corp/contactInfo', params).then((res) => {
                            const { data } = res;
                            this.info = Object.assign(data, {
                                admin_qq: data.admin_qq.length && data.admin_qq !== '0' ? data.admin_qq : '',
                                mobile: data.mobile.length && data.mobile !== '0' ? data.mobile : '',
                            });
                            this.dialogRender = true;
                            this.preName = data.name;
                            this.preEmail = data.email;
                            this.info.mobile && this.getAdminMobile();
                            resolve();
                    });
                });
            },
          changeMobile() {
            this.isChangeTel = true;
            this.toLoginAccount = false;
            this.changeMobileDlg = true;
          },
          toLoginMobile() {
            this.isChangeTel = false;
            this.toLoginAccount = true;
            this.changeMobileDlg = true;
          },
          handleChangeName() {
            this.isEditName = false;
            this.$refs.nameForm.submit();
          },
          submitName(e) {
            e && e.preventDefault();
            const params = {
                name: this.info.name,
            };
            this.$ajax.post('/mng/account/contacts/updateContactName', params).then((res) => {
                this.$message.success('更新成功');
            });
          },
          handleChangeEmail() {
            this.isEditEmail = false;
            this.$refs.emailForm.submit();
          },
          submitEmail(e) {
            e && e.preventDefault();
            const params = {
                email: this.info.email,
            };
            this.$ajax.post('/mng/account/contacts/updateContactEmail', params).then((res) => {
                this.$message.success('更新成功');
            });
          },
          /**
           * @desc 取消申请表
           */
          cancel() {
            this.dialogStatus = false;
            setTimeout(() => {
              this.dialogRender = false;
            });
          },
        },
    };
</script>

<style lang="less" scoped>
/deep/ .v-description-item--value {
    white-space: nowrap;
}
.contact {
    &-status {
        margin-top: 16px;

    }
    &-container {
        display: inline-block;
        width: 100%;

        &-item:nth-child(2n) {
            display: inline-block;
            width: 55%;
        }
        &-item:nth-child(odd) {
            display: inline-block;
            width: 45%;
        }
        .default-input {
            &-btn-group {
                display: inline-block;
                white-space: nowrap;
            }

            &-opt {
                margin-left: 24px;
            }

            &-err {
                border-color: #ff4222;
            }
            &-label {
                display: inline-block;
                width: 120px;
                text-align: left;
                margin-right: 8px;
                color: var(--text-color-text-caption, rgba(1, 11, 50, 0.41));
            }

            &-desc {
                position: absolute;
                font-size: 12px;
                line-height: 16px;
                padding: 4px 0;
                color: var(--text-color-text-caption, rgba(1, 11, 50, 0.41));
            }

            &-err {
                display: inline-block;
                color: #ff4222;
                line-height: 32px;
                height: 32px;
            }
        }

        a {
            cursor: pointer;
        }
    }
}
</style>
